import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { authHeaders, axiosInstance, isEmptyData } from '../../utils/helper';
import { timeout, VOUCHER_STATUS } from '../../utils/constants';

const initialState = {
	myVoucherGroup: [],
	b2bVoucherGroup: [],

	myVoucherList: [],
	listUseMyVoucher: [],

	myVoucherNominal: 0,
	myVoucherTotal: 0,

	b2bVoucherList: [],
	listUseB2BVoucher: [],

	b2bVoucherTotal: 0,
	b2bVoucherNominal: 0,
	b2BVoucherPrice: 0,
	b2BVoucherSaved: 0,

	autoApplyMyVoucher: false,
	applyB2BVoucher: false,
	customApplyVoucher: false,

	all: [],
	processing: [],
	completed: [],
	canceled: [],
	loading: false,
  detail: null,

  voucherGlobalList: [],
  isLoadingVoucherGlobalList: false,
};

export const getVoucherGlobalList = createAsyncThunk('voucher-global/list', async (body) => {
	if (isEmptyData(body)) return;
  const headers = {
    'Content-Type': 'application/json',
    ...authHeaders().headers,
  }
	const res = await axiosInstance.post(`voucher-global/list`, body, { headers, timeout });
	const data = await res.data?.data;
	return data;
});

export const getTopupList = createAsyncThunk('ultra-value/list-history-top-up', async (body) => {
	if (isEmptyData(body)) return;
  const headers = {
    'Content-Type': 'application/json'
  }
	const res = await axiosInstance.post(`ultra-value/list-history-top-up`, body, { headers });
	const data = await res.data;
	return data;
});

export const getTopupDetail = createAsyncThunk('ultra-value/detail-history', async (id) => {
	const res = await axiosInstance.get(`ultra-value/detail-history/${id}`);
	const data = await res.data;
	return data;
});

const groupByStatus = (data = []) => {
	return data.reduce((acc, current) => {
		const status = current.topup_status;
		if (!acc[status]) {
			acc[status] = [];
		}
		acc[status].push(current);
		return acc;
	}, {});
};

const voucher = createSlice({
	name: 'voucher',
	initialState,
	reducers: {
		setVoucher: (state, action) => {
			return { ...state, ...action.payload };
		},
		clearVoucher: () => {
			return initialState;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getTopupList.pending, (state) => {
				state.loading = true;
			})
			.addCase(getTopupList.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getTopupList.fulfilled, (state, action) => {
				state.loading = false;
				const data = action.payload?.data || [];
				const group = groupByStatus(data);

				state.all = data;
				state.processing = group[VOUCHER_STATUS.PROCESSING] || [];
				state.completed = group[VOUCHER_STATUS.COMPLETED] || [];
				state.canceled = group[VOUCHER_STATUS.CANCELED] || [];
			})
      .addCase(getTopupDetail.pending, (state) => {
				state.loading = true;
			})
			.addCase(getTopupDetail.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getTopupDetail.fulfilled, (state, action) => {
				state.loading = false;
				const data = action.payload?.data || null;
				state.detail = data;
			})
      .addCase(getVoucherGlobalList.pending, (state) => {
				state.isLoadingVoucherGlobalList = true;
			})
			.addCase(getVoucherGlobalList.fulfilled, (state, action) => {
				state.isLoadingVoucherGlobalList = false;
				state.voucherGlobalList = action.payload?.data;
			})
			.addCase(getVoucherGlobalList.rejected, (state) => {
				state.isLoadingVoucherGlobalList = false;
			})
	},
});

// Export actions and reducer
export const { setVoucher, clearVoucher } = voucher.actions;
export default voucher.reducer;
